
      export const versions = {
        version: '1.610.082035',
        revision: '50b69cd',
        branch: 'qa_deploy',
        npm_package_version: '0.0.0'
      };